import { Divider as MuiDivider, type DividerProps as MuiDividerProps } from '@mui/material';
import type { ReactNode } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type RuleProps = WithoutStyleOverrides<Omit<MuiDividerProps<'hr'>, 'absolute' | 'orientation' | 'children' | 'textAlign'>> & {
  listItem?: false;
  orientation?: 'horizontal';
  children?: never;
  textAlign?: never;
};

type SeparatorProps = WithoutStyleOverrides<Omit<MuiDividerProps<'div'>, 'absolute' | 'orientation' | 'children'>> & {
  listItem?: false;
} & (
  | { orientation: 'vertical'; children?: Exclude<ReactNode, undefined> }
  | { orientation?: 'horizontal'; children: Exclude<ReactNode, undefined> }
  );

type ListItemSeparatorProps = WithoutStyleOverrides<Omit<MuiDividerProps<'li'>, 'absolute'>> & {
  listItem: true;
};

type Props = RuleProps | SeparatorProps | ListItemSeparatorProps;

export function Divider(props: Props) {
  if (props.listItem) {
    const { listItem: _listItem, ...dividerProps } = props;
    return <MuiDivider {...dividerProps} component="li" />;
  }

  if (props.orientation === 'vertical' || props.children !== undefined) {
    const { listItem: _listItem, ...dividerProps } = props;
    return <MuiDivider {...dividerProps} component="div" />;
  }

  const { listItem: _listItem, ...dividerProps } = props;
  return <MuiDivider {...dividerProps} component="hr" />;
}

export type { Props as DividerProps };
